"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  computed: {
    language: function language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleSetLanguage: function handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("app/setLanguage", lang); // sessionStorage.setItem('language',lang);
      // console.log(sessionStorage.getItem('language'))
      // let code = this.$store.getters.language;
      // httpUtils.post("login", "setLanguage", {}, code).then((res) => {
      //   this.$message({
      //     message: res.msg,
      //     type: "success"
      //   });
      // }).catch(err=>{
      //   this.$notify({
      //     title: this.$t("common.error"),
      //     message: this.$t("common.fetchError")+','+err.message,
      //     type: "error"
      //   });
      // });
    }
  }
};
exports.default = _default;